import type { VehicleType } from "./protocol";

export interface VehicleSpec {
  label: string;
  description: string;
  topSpeed: number;
  acceleration: number;
  reverseAcceleration: number;
  steering: number;
  grip: number;
  driftGrip: number;
  airControl: number;
  mass: number;
  suspension: number;
  engineTone: number;
}

export const VEHICLE_SPECS: Record<VehicleType, VehicleSpec> = {
  racer: {
    label: "Racer GT",
    description: "Rapide, précise et équilibrée.",
    topSpeed: 54,
    acceleration: 31,
    reverseAcceleration: 17,
    steering: 1.85,
    grip: 8.2,
    driftGrip: 2.8,
    airControl: 1.1,
    mass: 1.15,
    suspension: 1,
    engineTone: 84,
  },
  moto: {
    label: "Moto Vortex",
    description: "La plus vive, mais exige de la finesse.",
    topSpeed: 58,
    acceleration: 34,
    reverseAcceleration: 13,
    steering: 2.18,
    grip: 6.8,
    driftGrip: 2.1,
    airControl: 1.45,
    mass: 0.78,
    suspension: 0.84,
    engineTone: 116,
  },
  scooter: {
    label: "Volt Scooter",
    description: "Accélération électrique et contrôle aérien.",
    topSpeed: 47,
    acceleration: 38,
    reverseAcceleration: 16,
    steering: 2.05,
    grip: 7.1,
    driftGrip: 2.4,
    airControl: 1.75,
    mass: 0.7,
    suspension: 0.92,
    engineTone: 156,
  },
  kart: {
    label: "Dune Kart",
    description: "Adhérence maximale et drift généreux.",
    topSpeed: 50,
    acceleration: 35,
    reverseAcceleration: 19,
    steering: 2.12,
    grip: 9.4,
    driftGrip: 3.4,
    airControl: 1.2,
    mass: 1,
    suspension: 1.12,
    engineTone: 72,
  },
};

export const VEHICLE_TYPES = Object.keys(VEHICLE_SPECS) as VehicleType[];

export function maximumPlausibleSpeed(vehicle: VehicleType | null): number {
  return vehicle ? VEHICLE_SPECS[vehicle].topSpeed * 1.7 : 90;
}
